export const mediaArticleSelector = state => state.mediaArticle.get('mediaArticle');
export const mediaArticleIsLoadingSelector = state => state.mediaArticle.get('isLoading');
